import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { ICardTab } from './typings';

@Component({
  selector: 'm-card-header-tab',
  exportAs: 'mCardHeaderTab',
  template: `
    <div class="m-header-tab-container">
      <ng-container *ngFor="let item of mTabList; let i = index">
        <div
          class="m-header-tab-title {{ mActiveTabName === item.name ? 'm-header-tab-selected' : '' }}"
          [style.background-color]="mActiveTabName !== item.name && mInitialBgColor"
          (click)="tabChange(item.name)"
        >
          <span>{{ item.name }}</span>
        </div>
      </ng-container>
      <div class="m-header-tab-right">
        <ng-template *ngIf="mTabExtraRef" [ngTemplateOutlet]="mTabExtraRef"></ng-template>
      </div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false
})
export class MCardHeaderTabComponent {
  @Input() mTabList?: ICardTab[] = [];
  @Input() mActiveTabName?: string;
  @Input() mInitialBgColor!: string;
  @Input() mTabExtraRef?: TemplateRef<void>;
  @Output() readonly mActiveTabNameChange = new EventEmitter<string>();

  tabChange(name: string): void {
    this.mActiveTabNameChange.emit(name);
  }
}
